import getApiBaseUrl from '@/utils/getBaseUrl';
import { useQuery } from '@tanstack/react-query';
import useGetProfile from './useGetProfile';

export interface Profile {
  emailAddress: string;
  firstName: string;
  lastName?: string;
  auth0Id: string;
  createdAt: string;
  phoneNumber?: string;
  role?: 'AGENT';
  companyName?: string;
  licenseNumber?: string;
  photoUrl?: string;
  website?: string;
  _id: string;
  identifier: string;
}

export default function useGetAgents() {
  const { data: user } = useGetProfile();
  const token = window.localStorage.getItem('_token');

  return useQuery<Profile[]>({
    queryKey: ['ADMIN_AGENTS'],
    queryFn: async () => {
      const response = await fetch(`${getApiBaseUrl()}/api/v1/users/agents`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch profile: ${response.statusText}`);
      }

      return (await response.json()).data.data;
    },
    enabled: user?.role === 'ADMIN',
  });
}
